function FinishPage({ dispatch, maxPossiblePoints, sumPoints }) {
  const percentage = (sumPoints / maxPossiblePoints) * 100;
  return (
    <>
      <p className="result">
        You Scored <strong>{sumPoints}</strong> out of {maxPossiblePoints} (
        {Math.ceil(percentage)}%)
      </p>
      <button
        className="btn btn-action"
        onClick={() => dispatch({ type: "restart" })}
      >
        Restart
      </button>
    </>
  );
}

export default FinishPage;
